/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  List,
  Form,
  Spin,
  message,
  Carousel,
  Tooltip,
  Radio,
  Text,
  Tabs,
  Modal,
  Table,
} from "antd";

import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined, PaperClipOutlined } from "@ant-design/icons";

import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useCopilotReadable } from "@copilotkit/react-core";

import "./index.scss";
import dashboardAnnouncementIcone from "../../assests/images/dashboard-annonsment.svg";
import dashbordMessageIcon from "../../assests/images/dashbord-message-icon.svg";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import calenderIcon from "../../assests/images/calenderIcon.svg";
import attachmentIcon from "../../assests/images/paperpin.svg";
import shipmentHeaderIcon from "../../assests/images/shipment-dashboard.svg";
import bagHeaderIcon from "../../assests/images/bag-dashboard.svg";
import dashboardTopIcon from "../../assests/images/dashboard-square-setting.svg";
import dashboardRefreshIcon from "../../assests/images/refresh.svg";
import quickActionTopIcon from "../../assests/images/setup-01.svg";
import liveTicketTopIcon from "../../assests/images/ticket-01.svg";

import { dashboardMenuList } from "../../config/dashboard";
import DashbordCard from "./DashbordCard";
import constants from "../../constants/messages";
import roleConstants from "../../constants/constants";
const { ROLES } = roleConstants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_HOMARKETING,
  ROLE_ZONALHEAD,
  ROLE_ZONALOPERATOR,
  ROLE_RM,
  ROLE_FUNCTIONALHEAD,
  ROLE_MD,
  ROLE_CENTRALOPERATOR,
  ROLE_BOOKINGAUDITONLY,
  ROLE_HUBOPERATOR,
  DEVELOPER,
  CUSTOMER_DELIGHT_EXECUTIVE,
  ROLE_CSO,
  ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM
} = ROLES;
import { getAccountService } from "../../actionsMethods/cashBookingMethods";
import {
  getDashboardOverview,
  getDashboardIncomingOverview,
  getDashboardOverviewBag,
  getDashboardIncomingOverviewBag,
  getDashboardIncomingBagsClickable,
  getDashboardOutscanBagsClickable,
  getDashboardOutscanToCpShipmentsClickable,
  getDashboardOutscanToCpBagsClickable,
  getDashboardInscanShipmentsClickable,
  getDashboardOutscanShipmentsClickable,
  getDashboardIncomingShipmentsClickable,
  getDashboardInscanBagsClickable
} from "../../actionsMethods/dashboardMethods";
import { APIs, getToken, getPremiseId } from "../../utils/worker";
import axios from "axios";
import API from "../../api";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import nodeURLs from "../../api/nodeUrls";
import { capitalize, showErrorMessage } from "../../utils";
import urls from "../../api/urls";
import { LiveTickets, TicketDetail } from "hubops-live-ticket-component";
import "hubops-live-ticket-component/dist/style.css";

const premiseId = getPremiseId();
const { SHIPMENT_COUNT, DASHBOARD_COUNT } = nodeURLs;
const { DASHBOARD_COUNT_NEW } = urls;

const { TabPane } = Tabs;

const incomingBagsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "date", key: "date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Bag Number",
    dataIndex: "bag_number",
    key: "bag_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Bag Type", dataIndex: "bag_type", key: "bag_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Shipments", dataIndex: "shipments", key: "shipments", render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "origin_hub_name", key: "origin_hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub_name", key: "destination_hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Weight", dataIndex: "bag_weight", key: "bag_weight", render: (text) => text || text === 0 ? text : "---" },
  { title: "Transport Mode", dataIndex: "transport_mode", key: "transport_mode", render: (text) => text || text === 0 ? text : "---" },
];

const outscanBagsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "date", key: "date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Bag Number",
    dataIndex: "bag_number",
    key: "bag_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Bag Type", dataIndex: "bag_type", key: "bag_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Shipments", dataIndex: "shipments", key: "shipments", render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "origin_hub", key: "origin_hub", render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub_name", key: "destination_hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Weight", dataIndex: "weight", key: "weight", render: (text) => text || text === 0 ? text : "---" },
  { title: "Transport Mode", dataIndex: "transport_mode", key: "transport_mode", render: (text) => text || text === 0 ? text : "---" },
];

const outscanToCPShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "date", key: "date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "From Hub", dataIndex: "from_hub", key: "from_hub", render: (text) => text || text === 0 ? text : "---" },
  { title: "To CP", dataIndex: "to_cp", key: "to_cp", render: (text) => text || text === 0 ? text : "---" },
];

const outscanToCPBagsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "date", key: "date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Bag Number",
    dataIndex: "bag_number",
    key: "bag_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "From Hub", dataIndex: "from_hub", key: "from_hub", render: (text) => text || text === 0 ? text : "---" },
  { title: "To CP", dataIndex: "to_cp", key: "to_cp", render: (text) => text || text === 0 ? text : "---" },
];

const inscanBagsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Inscan Date", dataIndex: "inscan_date", key: "inscan_date", width: 160, render: (text) => text ? moment(text).format("DD-MM-YYYY HH:mm") : "---" },
  {
    title: "Bag Number",
    dataIndex: "bag_number",
    key: "bag_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Inscan Hub", dataIndex: "inscan_hub", key: "inscan_hub", width: 250, render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "origin_hub", key: "origin_hub", width: 250, render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub", key: "destination_hub", width: 250, render: (text) => text || text === 0 ? text : "---" },
  { title: "Inscanned By", dataIndex: "inscanned_by", key: "inscanned_by", width: 200, render: (text) => text || text === 0 ? text : "---" },
  { title: "Bag Weight", dataIndex: "bag_weight", key: "bag_weight", render: (text) => text || text === 0 ? text : "---" },
  { title: "Content Type", dataIndex: "content_type", key: "content_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Mode", dataIndex: "mode", key: "mode", render: (text) => text || text === 0 ? text : "---" },
  { title: "Travel By", dataIndex: "travel_by", key: "travel_by", render: (text) => text || text === 0 ? text : "---" },
  { title: "Shipment Count", dataIndex: "shipment_count", key: "shipment_count", render: (text) => text || text === 0 ? text : "---" },
];

const inscanShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "operation_date", key: "operation_date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Hub Name", dataIndex: "hub_name", key: "hub_name", render: (text) => text || text === 0 ? text : "---" },
  { title: "Service Type", dataIndex: "service_type", key: "service_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Doc Type", dataIndex: "doc_type", key: "doc_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Travel Type", dataIndex: "travel_type", key: "travel_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Booking CP Name", dataIndex: "booking_cp_name", key: "booking_cp_name", render: (text) => text || text === 0 ? text : "---" },
];

const outscanShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Date", dataIndex: "operation_date", key: "operation_date", width: 120, render: (text) => text ? moment(text).format("DD-MM-YYYY") : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Origin Hub", dataIndex: "origin_hub", key: "origin_hub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Current Hub", dataIndex: "current_hub", key: "current_hub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destination_hub_name", key: "destination_hub_name", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Doc Type", dataIndex: "doctype", key: "doctype", render: (text) => text || text === 0 ? text : "---" },
  { title: "Service Type", dataIndex: "service_type", key: "service_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Mode", dataIndex: "mode", key: "mode", render: (text) => text || text === 0 ? text : "---" },
  { title: "Status", dataIndex: "status", key: "status", render: (text) => text || text === 0 ? text : "---" },
];

const incomingShipmentsColumns = [
  { title: "S.No", dataIndex: "_sno", key: "_sno", width: 60, render: (text) => text || text === 0 ? text : "---" },
  { title: "Booking Complete Time", dataIndex: "booking_complete_time", key: "booking_complete_time", width: 200, render: (text) => text ? <span style={{ whiteSpace: "nowrap" }}>{moment(text).format("DD-MM-YYYY HH:mm")}</span> : "---" },
  { title: "Date", dataIndex: "operation_date", key: "operation_date", width: 150, render: (text) => text ? <span style={{ whiteSpace: "nowrap" }}>{moment(text).format("DD-MM-YYYY")}</span> : "---" },
  {
    title: "Shipment Number",
    dataIndex: "awb_number",
    key: "awb_number",
    width: 180,
    render: (text) => text ? <a href={`/shipment-tracker?awb=${text}`} target="_blank" rel="noopener noreferrer">{text}</a> : "---"
  },
  { title: "Doc Type", dataIndex: "doc_type", key: "doc_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Mode", dataIndex: "mode", key: "mode", render: (text) => text || text === 0 ? text : "---" },
  { title: "Origin Hub", dataIndex: "originhub", key: "originhub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "State", dataIndex: "state", key: "state", width: 160, render: (text) => text || text === 0 ? text : "---" },
  { title: "Zone", dataIndex: "zone", key: "zone", render: (text) => text || text === 0 ? text : "---" },
  { title: "Current Center", dataIndex: "current_center_name", key: "current_center_name", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Destination Hub", dataIndex: "destinationhub", key: "destinationhub", width: 220, render: (text) => text || text === 0 ? text : "---" },
  { title: "Status", dataIndex: "status", key: "status", width: 180, render: (text) => text || text === 0 ? text : "---" },
  { title: "Booking Type", dataIndex: "booking_type", key: "booking_type", render: (text) => text || text === 0 ? text : "---" },
  { title: "Service Type", dataIndex: "service_type", key: "service_type", render: (text) => text || text === 0 ? text : "---" },
];

function Dashboard() {
  const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
  const getRole = userinfo?.roles?.[0]?.replace(/.*_/, "");
  const showDashboardSection =
    getRole === "HUBADMIN" || getRole === "HUBOPERATOR" || getRole === "DEVELOPER";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { ANNOUNCEMENT } = constants;
  const { DASHBORD_SCANNED_UNSCANNED, GET_REGEX_PATTERN } = urls;

  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);

  const [accountDetails, setAccountDetails] = useState();
  const [day, setDay] = useState(1);
  const [onClickTime, setOnClickTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [todayData, setTodayData] = useState([]);
  const [activeTab, setActiveTab] = useState("hub");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isAnnouncementModalVisible, setIsAnnouncementModalVisible] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [cardDetailsModal, setCardDetailsModal] = useState({ visible: false, title: "", count: 0 });
  const [incomingBagsData, setIncomingBagsData] = useState([]);
  const [incomingBagsPagination, setIncomingBagsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isIncomingBagsLoading, setIsIncomingBagsLoading] = useState(false);
  const [outscanBagsData, setOutscanBagsData] = useState([]);
  const [outscanBagsPagination, setOutscanBagsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isOutscanBagsLoading, setIsOutscanBagsLoading] = useState(false);
  const [outscanToCPShipmentsData, setOutscanToCPShipmentsData] = useState([]);
  const [outscanToCPShipmentsPagination, setOutscanToCPShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isOutscanToCPShipmentsLoading, setIsOutscanToCPShipmentsLoading] = useState(false);
  const [outscanToCPBagsData, setOutscanToCPBagsData] = useState([]);
  const [outscanToCPBagsPagination, setOutscanToCPBagsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isOutscanToCPBagsLoading, setIsOutscanToCPBagsLoading] = useState(false);
  const [inscanShipmentsData, setInscanShipmentsData] = useState([]);
  const [inscanShipmentsPagination, setInscanShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isInscanShipmentsLoading, setIsInscanShipmentsLoading] = useState(false);
  const [outscanShipmentsData, setOutscanShipmentsData] = useState([]);
  const [outscanShipmentsPagination, setOutscanShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isOutscanShipmentsLoading, setIsOutscanShipmentsLoading] = useState(false);
  const [incomingShipmentsData, setIncomingShipmentsData] = useState([]);
  const [incomingShipmentsPagination, setIncomingShipmentsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isIncomingShipmentsLoading, setIsIncomingShipmentsLoading] = useState(false);
  const [inscanBagsData, setInscanBagsData] = useState([]);
  const [inscanBagsPagination, setInscanBagsPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [isInscanBagsLoading, setIsInscanBagsLoading] = useState(false);
  const [rightPanelView, setRightPanelView] = useState("live");
  const statsContentRef = useRef(null);
  const liveTicketPanelRef = useRef(null);
  const quickActionPanelRef = useRef(null);

  useLayoutEffect(() => {
    const syncPanelHeights = () => {
      const livePanelEl = liveTicketPanelRef.current;
      const quickPanelEl = quickActionPanelRef.current;

      if (showDashboardSection) {
        if (quickPanelEl) quickPanelEl.style.height = "";
        const statsEl = statsContentRef.current;
        if (!statsEl || !livePanelEl) return;
        livePanelEl.style.height = `${statsEl.offsetHeight}px`;
        return;
      }

      if (livePanelEl) livePanelEl.style.height = "";
      if (!livePanelEl || !quickPanelEl) return;
      quickPanelEl.style.height = `${livePanelEl.offsetHeight}px`;
    };

    const runSync = () => {
      requestAnimationFrame(syncPanelHeights);
    };

    runSync();

    const resizeObserver = new ResizeObserver(runSync);
    const observeEl = showDashboardSection
      ? statsContentRef.current
      : liveTicketPanelRef.current;
    if (observeEl) {
      resizeObserver.observe(observeEl);
    }

    window.addEventListener("resize", runSync);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", runSync);
      if (liveTicketPanelRef.current) {
        liveTicketPanelRef.current.style.height = "";
      }
      if (quickActionPanelRef.current) {
        quickActionPanelRef.current.style.height = "";
      }
    };
  }, [
    showDashboardSection,
    todayData,
    loading,
    activeTab,
    rightPanelView,
    accountDetails,
  ]);

  // Make dashboard data available to CopilotKit
  useCopilotReadable({
    description: "Current dashboard data including shipment counts, user information, and operational metrics",
    value: {
      currentUser: {
        username: accountDetails?.username,
        role: getRole,
        roles: userinfo?.roles || [],
        premiseId: premiseId?.split("Bearer ")[1]
      },
      dashboardMetrics: {
        activeTab: activeTab,
        selectedDay: day,
        todayData: todayData,
        loading: loading
      },
      availableMenuItems: dashboardMenuList.filter(item =>
        item.role.some(role => userinfo?.roles?.includes(role))
      ).map(item => ({
        title: item.title,
        id: item.id,
        route: item.route
      })),
      announcements: dataSource?.length > 0 ? dataSource.map(announcement => ({
        title: announcement.title,
        content: announcement.message,
        date: announcement.createdDate
      })) : [],
      shipmentStatus: todayData ? {
        inbound: todayData.inbound || {},
        outbound: todayData.outbound || {},
        hubOperations: todayData.hubOperations || {}
      } : null,
      currentTime: day,
      lastUpdated: new Date().toISOString()
    }
  });

  // Make dashboard menu configuration available
  useCopilotReadable({
    description: "Dashboard menu configuration and available features based on user role",
    value: {
      userRole: getRole,
      availableFeatures: dashboardMenuList
        .filter(item => item.role.some(role => userinfo?.roles?.includes(role)))
        .map(item => ({
          name: item.title,
          id: item.id,
          route: item.route,
          description: `Navigate to ${item.title} section`
        })),
      roleBasedAccess: {
        canAccessBooking: userinfo?.roles?.includes(CP_ADMIN),
        canAccessHubOperations: userinfo?.roles?.includes(HUB_ADMIN) || userinfo?.roles?.includes(ROLE_HUBOPERATOR),
        canAccessReports: userinfo?.roles?.some(role =>
          [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM].includes(role)
        ),
        canAccessMasterSettings: userinfo?.roles?.some(role =>
          [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM].includes(role)
        )
      }
    }
  });

  // Make operational data available
  useCopilotReadable({
    description: "Real-time operational data and shipment tracking information",
    value: {
      operationalData: todayData ? {
        inboundShipments: {
          incoming: todayData.inbound?.incoming || 0,
          inscan: todayData.inbound?.inscan || 0,
          pending: todayData.inbound?.pending || 0,
          total: (todayData.inbound?.incoming || 0) + (todayData.inbound?.inscan || 0) + (todayData.inbound?.pending || 0)
        },
        outboundShipments: {
          outscan: todayData.outbound?.outscan || 0,
          pending: todayData.outbound?.pending || 0,
          total: (todayData.outbound?.outscan || 0) + (todayData.outbound?.pending || 0)
        },
        summary: {
          totalInbound: (todayData.inbound?.incoming || 0) + (todayData.inbound?.inscan || 0) + (todayData.inbound?.pending || 0),
          totalOutbound: (todayData.outbound?.outscan || 0) + (todayData.outbound?.pending || 0),
          totalPending: (todayData.inbound?.pending || 0) + (todayData.outbound?.pending || 0)
        }
      } : null,
      dataFreshness: {
        lastRefresh: new Date().toISOString(),
        selectedPeriod: day,
        isLoading: loading
      }
    }
  });

  useEffect(() => {
    //initialize();
    getRegexPattern();
  }, []);
  const getpremiseResponse = useSelector(
    (state) => state?.appReducer?.getCpPremiseReducer,
    shallowEqual
  );

  const { fetching, result } = getpremiseResponse;

  useEffect(() => {
    if (!fetching) {
      localStorage.setItem(
        "permises",
        JSON.stringify(result, getpremiseResponse?.result?.premises?.stateCode)
      );
    }
  }, [getpremiseResponse]);

  function getDate(day = "today") {
    const date = new Date();
    setDay(`${moment().format("hh:mm a")}  ${day}`);
    if (day === "yesterday") {
      setDay(day);
      // setOnClickTime(day);
      date.setDate(date.getDate() - 1);
    }

    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  }

  useEffect(() => {
    navigate("/dashboard", { state: { test: "test" } });

    if (showDashboardSection) {
      getTodaysData("today");
    }
    setAccountDetails(JSON.parse(localStorage.getItem("userinfo")));
    getAnnouncements();
  }, []);

  useEffect(() => {
    if (accountDetails !== undefined) {
      dispatch(getAccountService(accountDetails?.username));
    }
  }, [accountDetails]);

  const getTodaysData = async (day) => {
    let dates = getDate(day);
    getScannedAndUnscanned();
  };
  const getRegexPattern = async () => {
    let response = await API.Api(GET_REGEX_PATTERN).getRegexPatternHeader();
    if (response.status) {
      console.log("API Response:", response?.response?.data);
      const pattern = response?.response?.data?.data?.configValue?.pattern;
      console.log("Pattern to store:", pattern);
      if (pattern) {
        localStorage.setItem("regexPattern", pattern);
        console.log("Stored in localStorage:", localStorage.getItem("regexPattern"));
      } else {
        console.error("No pattern found in response");
      }
    }
  };
  const dashboardOverviewResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOverviewReducer,
    shallowEqual
  );

  const dashboardIncomingOverviewResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardIncomingOverviewReducer,
    shallowEqual
  );

  const dashboardOverviewBagResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOverviewBagReducer,
    shallowEqual
  );

  const dashboardIncomingOverviewBagResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardIncomingOverviewBagReducer,
    shallowEqual
  );

  const dashboardIncomingBagsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardIncomingBagsClickableReducer,
    shallowEqual
  );

  const dashboardOutscanBagsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOutscanBagsClickableReducer,
    shallowEqual
  );

  const dashboardOutscanToCpShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOutscanToCpShipmentsClickableReducer,
    shallowEqual
  );

  const dashboardOutscanToCpBagsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOutscanToCpBagsClickableReducer,
    shallowEqual
  );

  const dashboardInscanShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardInscanShipmentsClickableReducer,
    shallowEqual
  );

  const dashboardOutscanShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardOutscanShipmentsClickableReducer,
    shallowEqual
  );

  const dashboardIncomingShipmentsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardIncomingShipmentsClickableReducer,
    shallowEqual
  );
  const dashboardInscanBagsClickableResponse = useSelector(
    (state) => state?.dashboardReducer?.getDashboardInscanBagsClickableReducer,
    shallowEqual
  );

  useEffect(() => {
    if (dashboardOverviewResponse) {
      const { fetching, result, error } = dashboardOverviewResponse;
      setLoading(fetching);
      if (result && !fetching) {
        const dataArr = result.data;
        if (dataArr && Array.isArray(dataArr) && dataArr.length > 0) {
          const overviewData = dataArr[0];
          setTodayData(prev => ({
            ...prev,
            [activeTab]: {
              ...(prev?.[activeTab] || {}),
              shipment_wise: {
                ...(prev?.[activeTab]?.shipment_wise || {}),
                inscan: overviewData.inscan_shipment || 0,
                outscan: overviewData.outscan_shipment || 0,
                pending: overviewData.outscan_to_cp_shipments || 0
              }
            }
          }));
        }
      }
    }
  }, [dashboardOverviewResponse, activeTab]);

  useEffect(() => {
    if (dashboardIncomingOverviewResponse) {
      const { fetching, result, error } = dashboardIncomingOverviewResponse;
      // You can add setLoading(fetching) if you want to block on this request as well
      if (result && !fetching) {
        const dataArr = result.data;
        if (dataArr && Array.isArray(dataArr) && dataArr.length > 0) {
          const overviewData = dataArr[0];
          setTodayData(prev => ({
            ...prev,
            [activeTab]: {
              ...(prev?.[activeTab] || {}),
              shipment_wise: {
                ...(prev?.[activeTab]?.shipment_wise || {}),
                incoming: overviewData.incoming_shipment || 0,
              }
            }
          }));
        }
      }
    }
  }, [dashboardIncomingOverviewResponse, activeTab]);

  useEffect(() => {
    if (dashboardOverviewBagResponse) {
      const { fetching, result, error } = dashboardOverviewBagResponse;
      if (result && !fetching) {
        const dataArr = result.data;
        if (dataArr && Array.isArray(dataArr) && dataArr.length > 0) {
          const overviewData = dataArr[0];
          setTodayData(prev => ({
            ...prev,
            [activeTab]: {
              ...(prev?.[activeTab] || {}),
              bag_wise: {
                ...(prev?.[activeTab]?.bag_wise || {}),
                inscan: overviewData.inscan_bags || 0,
                outscan: overviewData.outscan_bags || 0,
                pending: overviewData.outscan_to_cp_bags || 0
              }
            }
          }));
        }
      }
    }
  }, [dashboardOverviewBagResponse, activeTab]);

  useEffect(() => {
    if (dashboardIncomingOverviewBagResponse) {
      const { fetching, result, error } = dashboardIncomingOverviewBagResponse;
      if (result && !fetching) {
        const dataArr = result.data;
        if (dataArr && Array.isArray(dataArr) && dataArr.length > 0) {
          const overviewData = dataArr[0];
          setTodayData(prev => ({
            ...prev,
            [activeTab]: {
              ...(prev?.[activeTab] || {}),
              bag_wise: {
                ...(prev?.[activeTab]?.bag_wise || {}),
                incoming: overviewData.incoming_bags || 0,
              }
            }
          }));
        }
      }
    }
  }, [dashboardIncomingOverviewBagResponse, activeTab]);

  useEffect(() => {
    if (dashboardIncomingBagsClickableResponse) {
      const { fetching, result, error } = dashboardIncomingBagsClickableResponse;
      setIsIncomingBagsLoading(fetching);
      if (result && !fetching) {
        setIncomingBagsData(result.data || []);
        if (result.pagination) {
          setIncomingBagsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardIncomingBagsClickableResponse]);

  useEffect(() => {
    if (dashboardOutscanBagsClickableResponse) {
      const { fetching, result, error } = dashboardOutscanBagsClickableResponse;
      setIsOutscanBagsLoading(fetching);
      if (result && !fetching) {
        setOutscanBagsData(result.data || []);
        if (result.pagination) {
          setOutscanBagsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardOutscanBagsClickableResponse]);

  useEffect(() => {
    if (dashboardOutscanToCpShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardOutscanToCpShipmentsClickableResponse;
      setIsOutscanToCPShipmentsLoading(fetching);
      if (result && !fetching) {
        setOutscanToCPShipmentsData(result.data || []);
        if (result.pagination) {
          setOutscanToCPShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardOutscanToCpShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardOutscanToCpBagsClickableResponse) {
      const { fetching, result, error } = dashboardOutscanToCpBagsClickableResponse;
      setIsOutscanToCPBagsLoading(fetching);
      if (result && !fetching) {
        setOutscanToCPBagsData(result.data || []);
        if (result.pagination) {
          setOutscanToCPBagsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardOutscanToCpBagsClickableResponse]);

  useEffect(() => {
    if (dashboardInscanShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardInscanShipmentsClickableResponse;
      setIsInscanShipmentsLoading(fetching);
      if (result && !fetching) {
        setInscanShipmentsData(result.data || []);
        if (result.pagination) {
          setInscanShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardInscanShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardOutscanShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardOutscanShipmentsClickableResponse;
      setIsOutscanShipmentsLoading(fetching);
      if (result && !fetching) {
        setOutscanShipmentsData(result.data || []);
        if (result.pagination) {
          setOutscanShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardOutscanShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardIncomingShipmentsClickableResponse) {
      const { fetching, result, error } = dashboardIncomingShipmentsClickableResponse;
      setIsIncomingShipmentsLoading(fetching);
      if (result && !fetching) {
        setIncomingShipmentsData(result.data || []);
        if (result.pagination) {
          setIncomingShipmentsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardIncomingShipmentsClickableResponse]);

  useEffect(() => {
    if (dashboardInscanBagsClickableResponse) {
      const { fetching, result, error } = dashboardInscanBagsClickableResponse;
      setIsInscanBagsLoading(fetching);
      if (result && !fetching) {
        setInscanBagsData(result.data || []);
        if (result.pagination) {
          setInscanBagsPagination({
            current: result.pagination.currentPage + 1,
            pageSize: result.pagination.pageSize,
            total: result.pagination.totalRecords,
          });
        }
      }
    }
  }, [dashboardInscanBagsClickableResponse]);

  const getScannedAndUnscanned = async () => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }

    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;

    let tabValue = activeTab === "cp" ? "PAST" : undefined;

    dispatch(getDashboardOverview({ premiseId: effectivePremiseId, tab: tabValue }));
    dispatch(getDashboardIncomingOverview({ topremiseid: effectivePremiseId, tab: tabValue }));
    dispatch(getDashboardOverviewBag({ premiseId: effectivePremiseId, tab: tabValue }));
    dispatch(getDashboardIncomingOverviewBag({ topremiseid: effectivePremiseId, tab: tabValue }));
  };

  useEffect(() => {
    if (showDashboardSection) {
      getScannedAndUnscanned();
    }
  }, [activeTab]);

  const handleCardClick = (title, count) => {
    if (count === 0) return;
    setCardDetailsModal({ visible: true, title, count });
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;

    if (title === "Incoming Bag") {
      setIncomingBagsData([]);
      setIncomingBagsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardIncomingBagsClickable({ topremiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    } else if (title === "Outscan Bag") {
      setOutscanBagsData([]);
      setOutscanBagsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardOutscanBagsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    } else if (title === "Outscan To CP Bags") {
      setOutscanToCPBagsData([]);
      setOutscanToCPBagsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardOutscanToCpBagsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    } else if (title === "Outscan To CP Shipments") {
      setOutscanToCPShipmentsData([]);
      setOutscanToCPShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardOutscanToCpShipmentsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    } else if (title === "Available Shipment") {
      setInscanShipmentsData([]);
      setInscanShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardInscanShipmentsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    } else if (title === "Outscan Shipment") {
      setOutscanShipmentsData([]);
      setOutscanShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardOutscanShipmentsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    } else if (title === "Incoming Shipment") {
      setIncomingShipmentsData([]);
      setIncomingShipmentsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardIncomingShipmentsClickable({ incominghubid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    } else if (title === "Available Bag") {
      setInscanBagsData([]);
      setInscanBagsPagination({ current: 1, pageSize: 10, total: 0 });
      dispatch(getDashboardInscanBagsClickable({ premiseid: effectivePremiseId, tab: tabValue, page: 0, size: 10 }));
    }
  };

  const handleIncomingBagsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardIncomingBagsClickable({
      topremiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleOutscanBagsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardOutscanBagsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleOutscanToCpShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardOutscanToCpShipmentsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleOutscanToCpBagsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardOutscanToCpBagsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleInscanShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardInscanShipmentsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleOutscanShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardOutscanShipmentsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleIncomingShipmentsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardIncomingShipmentsClickable({
      incominghubid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const handleInscanBagsTableChange = (pagination) => {
    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }
    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;
    let tabValue = activeTab === "cp" ? "PAST" : undefined;
    dispatch(getDashboardInscanBagsClickable({
      premiseid: effectivePremiseId,
      tab: tabValue,
      page: pagination.current - 1,
      size: pagination.pageSize
    }));
  };

  const getAnnouncements = async () => {
    const token = getToken();
    if (!token) return;

    try {
      let response = await axios.get(
        `${APIs.baseURL}/broadcast-service/v1/broadcasts/show`,
        {
          headers: {
            Authorization: getToken(),
            token: getToken()?.split("Bearer ")[1],
            "SMCS-PREMISE-ID": premiseId?.split("Bearer ")[1],
          },
        }
      );
      if (response?.status == 200) {
        console.log("Announcements Data:", response.data);
        setDataSource(response?.data);
      }
    } catch (error) {
      message.config({ top: 80 });
      showErrorMessage(error?.response?.data?.message);
    }
  };

  const isVideo = (url) => {
    if (!url) return false;
    return url.match(/\.(mp4|webm|ogg|mov|avi)(\?|#|$)/i);
  };

  const isImage = (url) => {
    if (!url) return false;
    return url.match(/\.(jpeg|jpg|gif|png|webp)(\?|#|$)/i);
  };

  const isPdf = (url) => {
    if (!url) return false;
    return url.match(/\.pdf(\?|#|$)/i);
  };

  const getFileName = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    const name = parts[parts.length - 1].split("?")[0];
    return decodeURIComponent(name);
  };

  const cleanHtml = (html) => {
    if (!html) return "";
    return html.replace(/(<br\s*\/?>|&nbsp;|\s)+$/gi, "").replace(/<p>(&nbsp;|\s)*<\/p>$/gi, "");
  };

  const getAttachmentUrl = (record) => {
    let url = record?.filePath ||
      record?.file ||
      record?.fileUrl ||
      record?.file_path ||
      record?.attachmentUrl ||
      record?.attachment ||
      record?.mediaPath ||
      record?.media_path;

    if (!url && record?.message) {
      const srcMatch = record.message.match(/src=['"]([^'"]+)['"]/i);
      const hrefMatch = record.message.match(/href=['"]([^'"]+)['"]/i);
      url = srcMatch ? srcMatch[1] : (hrefMatch ? hrefMatch[1] : null);
    }
    return url;
  };

  const showAnnouncement = (item) => {
    setSelectedAnnouncement(item);
    setIsAnnouncementModalVisible(true);
  };

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <RightOutlined />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <LeftOutlined />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const radioOnChange = (event) => {
    console.log(event);
  };

  const visibleMenuItems = dashboardMenuList.filter(
    (item) =>
      !item.hideOnDashboard &&
      (item?.role === "" || item.role.some((e) => accountDetails?.roles?.includes(e)))
  );

  return (
    <div
      className={`dashboard-container${showDashboardSection ? "" : " dashboard-container--without-dashboard"
        }${rightPanelView === "announcements"
          ? " dashboard-container--announcements-view"
          : ""
        }`}
    >
      <Spin spinning={fetching}>
        <Form
          form={form}
          layout="vertical"
          // onFinish={onFinish}
          autoComplete="off"
        >
          <div className="dashboard-top-strip">
            {showDashboardSection && (
              <div className="dashboard-top-card dashboard-top-card-left">
                <div className="dashboard-top-title">
                  <img
                    src={dashboardTopIcon}
                    alt="dashboard icon"
                    className="dashboard-top-title-icon"
                  />
                  Dashboard
                </div>
              </div>
            )}
            {!showDashboardSection && (
              <div className="dashboard-top-card dashboard-top-card-quick-top">
                <div className="dashboard-top-title">
                  <img
                    src={quickActionTopIcon}
                    alt="quick action icon"
                    className="dashboard-top-title-icon"
                  />
                  Quick Action
                </div>
              </div>
            )}
            <div className="dashboard-top-card dashboard-top-card-live">
              <div
                className={`dashboard-top-title dashboard-top-title-right dashboard-top-title-toggle${rightPanelView === "live" ? " is-active" : ""
                  }`}
                onClick={() => setRightPanelView("live")}
                role="button"
                tabIndex={0}
              >
                <img
                  src={liveTicketTopIcon}
                  alt="live tickets icon"
                  className="dashboard-top-title-icon"
                />
                Live Tickets
              </div>
            </div>
          </div>

          <Row
            gutter={[12, 24]}
            className={`dashboard-container-row${showDashboardSection
              ? " dashboard-container-row--stats-sync"
              : " dashboard-container-row--quick-action-sync"
              }`}
          >
            <Col
              className="dashboard-container-col"
              xl={12}
              lg={12}
              md={24}
              sm={24}
              xs={24}
            >
              {!showDashboardSection && (
                <div className="dashboard-quick-action-inline">
                  <div
                    ref={quickActionPanelRef}
                    className="dashboard-quick-action-panel dashboard-quick-action-panel-inline"
                  >
                    <Row gutter={[8, 0]} className="dashboard-quick-action-inline-row">
                      {visibleMenuItems.map((item, index) => (
                        <Col
                          className="cash-booking quick-action-card"
                          key={index}
                        >
                          <DashbordCard
                            accountBookingArrowIcon={accountBookingArrowIcon}
                            accountBookingIcon={item.icon}
                            watchIcon={calenderIcon}
                            bookingType={item.title}
                            route={item.route}
                            id={item.id}
                            newReportUrl={item.newReportUrl}
                          />
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              )}
              {showDashboardSection && (
                <Spin spinning={todayData === null}>
                  <Row>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      ref={statsContentRef}
                      className="dashboard-container-col-innercol dashboard-container-col-innercol--plain dashboard-stats-content"
                    >
                      <Row>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                          <CustomTabs
                            className="pl-1"
                            activeTab={activeTab}
                            tabChange={(e) => setActiveTab(e)}
                          />
                        </Col>
                      </Row>
                      <Spin spinning={loading}>
                        <div className="custom-carousel">
                          <StatusRow
                            title="Shipments"
                            type="shipment"
                            status={{
                              incoming: todayData[activeTab]?.shipment_wise?.incoming,
                              inscan: todayData[activeTab]?.shipment_wise?.inscan,
                              outscan: todayData[activeTab]?.shipment_wise?.outscan,
                              pending: todayData[activeTab]?.shipment_wise?.pending,
                            }}
                            onCardClick={handleCardClick}
                          />
                          {/* {activeTab == "inbound" && ( */}
                          <StatusRow
                            title="Bags"
                            type="bag"
                            // status={{
                            //   expected: todayData[activeTab]?.expected?.bag,
                            //   arrived: todayData[activeTab]?.arrived?.bag,
                            //   inscanned: todayData[activeTab]?.inscanned?.bag,
                            //   outscanned: todayData[activeTab]?.outscanned?.bag,
                            //   pendingInscan:
                            //     todayData[activeTab]?.pendingInscan?.bag,
                            // }}
                            status={{
                              incoming: todayData[activeTab]?.bag_wise?.incoming,
                              inscan: todayData[activeTab]?.bag_wise?.inscan,
                              outscan: todayData[activeTab]?.bag_wise?.outscan,
                              pending: todayData[activeTab]?.bag_wise?.pending,
                            }}
                            onCardClick={handleCardClick}
                          />
                          {/* )} */}
                        </div>
                      </Spin>
                    </Col>
                  </Row>
                </Spin>
              )}
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24} className="dashboard-right-col">
              <div
                ref={liveTicketPanelRef}
                className="dashboard-live-ticket-panel dashboard-live-ticket-panel-tall"
              >
                {rightPanelView === "live" && (
                  <>
                    <LiveTickets
                      config={{
                        env: process.env.REACT_APP_ENV || "dev",
                        limit: 3,
                      }}
                      onTicketClick={setSelectedTicket}
                    />

                    <TicketDetail
                      ticket={selectedTicket}
                      onClose={() => setSelectedTicket(null)}
                    />
                  </>
                )}
                {rightPanelView === "announcements" && (
                  <div className="dashboard-right-announcement-panel">
                    {dataSource.length > 0 ? (
                      <List
                        itemLayout="horizontal"
                        dataSource={dataSource}
                        pagination={
                          dataSource.length > 3
                            ? {
                              pageSize: 3,
                            }
                            : false
                        }
                        renderItem={(item) => (
                          <List.Item
                            style={{ cursor: "pointer" }}
                            onClick={() => showAnnouncement(item)}
                          >
                            <List.Item.Meta
                              title={
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      overflow: "hidden",
                                      flex: 1,
                                    }}
                                  >
                                    <img
                                      width="24px"
                                      height="24px"
                                      className="dashboard-container-card-div-messageIcon"
                                      src={dashbordMessageIcon}
                                      style={{ minWidth: "24px" }}
                                    />
                                    <span
                                      className="listTitle"
                                      style={{
                                        textTransform: "capitalize",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        marginLeft: "8px",
                                        color:
                                          item.priorityType === "HIGH"
                                            ? "#C40000"
                                            : item.priorityType === "MEDIUM"
                                              ? "#DF8100"
                                              : "#179503",
                                      }}
                                      title={item.title}
                                    >
                                      {item.title}
                                    </span>
                                  </div>
                                  {getAttachmentUrl(item) && (
                                    <Tooltip title="View Attachment">
                                      <img
                                        width="24px"
                                        height="24px"
                                        style={{
                                          marginLeft: "8px",
                                          verticalAlign: "middle",
                                          cursor: "pointer",
                                        }}
                                        src={attachmentIcon}
                                        alt="attachment"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              }
                              description={
                                <span className="listDiscription">
                                  {item.validFrom + " - " + item.validTo}
                                </span>
                              }
                            />
                          </List.Item>
                        )}
                      />
                    ) : (
                      <div className="dashboard-right-announcement-empty">
                        No announcements available
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {showDashboardSection && (
            <div className="dashboard-bottom-strip">
              <div className="dashboard-top-card dashboard-top-card-quick-bottom">
                <div className="dashboard-top-title">
                  <img
                    src={quickActionTopIcon}
                    alt="quick action icon"
                    className="dashboard-top-title-icon"
                  />
                  Quick Action
                </div>
              </div>
              <div className="dashboard-quick-action-panel dashboard-quick-action-panel-bottom">
                <Row gutter={[8, 0]} className="dashboard-quick-action-row">
                  {visibleMenuItems.map((item, index) => (
                    <Col
                      className="cash-booking quick-action-card"
                      key={index}
                    >
                      <DashbordCard
                        accountBookingArrowIcon={accountBookingArrowIcon}
                        accountBookingIcon={item.icon}
                        watchIcon={calenderIcon}
                        bookingType={item.title}
                        route={item.route}
                        id={item.id}
                        newReportUrl={item.newReportUrl}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          )}

        </Form>
      </Spin>
      <Modal
        title={selectedAnnouncement?.title}
        visible={isAnnouncementModalVisible}
        onCancel={() => setIsAnnouncementModalVisible(false)}
        footer={false}
        width={650}
        className="square-modal"
      >
        <div className="modal-content-wrapper">
          <div
            className="message-content"
            style={{ fontSize: "14px", lineHeight: "1.6" }}
            dangerouslySetInnerHTML={{ __html: cleanHtml(selectedAnnouncement?.message) }}
          ></div>
          {getAttachmentUrl(selectedAnnouncement) && (
            <div className="media-preview" style={{ textAlign: "center", background: "#f5f5f5", padding: "0 10px 10px 10px", borderRadius: "8px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              {isVideo(getAttachmentUrl(selectedAnnouncement)) ? (
                <video
                  key={getAttachmentUrl(selectedAnnouncement)}
                  width="100%"
                  controls
                  autoPlay
                  muted
                  playsInline
                  src={getAttachmentUrl(selectedAnnouncement)}
                  style={{ borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                >
                  Your browser does not support the video tag.
                </video>
              ) : isImage(getAttachmentUrl(selectedAnnouncement)) ? (
                <img
                  src={getAttachmentUrl(selectedAnnouncement)}
                  alt="Attachment"
                  style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                />
              ) : isPdf(getAttachmentUrl(selectedAnnouncement)) ? (
                <iframe
                  src={getAttachmentUrl(selectedAnnouncement)}
                  width="100%"
                  height="400px"
                  style={{ border: "none", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                  title="PDF Preview"
                >
                  Your browser does not support iframes.
                  <a href={getAttachmentUrl(selectedAnnouncement)} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </iframe>
              ) : (
                <div className="file-attachment">
                  <a href={getAttachmentUrl(selectedAnnouncement)} target="_blank" rel="noopener noreferrer">
                    View Attachment
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
      <Modal
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: "50px" }}>
            <span>{cardDetailsModal?.title}</span>
            {["Incoming Bag", "Outscan Bag", "Outscan To CP Bags", "Outscan To CP Shipments", "Available Shipment", "Outscan Shipment", "Incoming Shipment", "Available Bag"].includes(cardDetailsModal?.title) && (
              <span style={{ fontSize: "14px", fontWeight: "600", color: "#061624" }}>Total Count: {cardDetailsModal?.count}</span>
            )}
          </div>
        }
        visible={cardDetailsModal?.visible}
        onCancel={() => setCardDetailsModal(prev => ({ ...prev, visible: false }))}
        footer={false}
        width={
          cardDetailsModal?.title === "Incoming Bag" ||
            cardDetailsModal?.title === "Outscan Bag" ||
            cardDetailsModal?.title === "Outscan To CP Bags" ||
            cardDetailsModal?.title === "Outscan To CP Shipments" ||
            cardDetailsModal?.title === "Available Shipment" ||
            cardDetailsModal?.title === "Outscan Shipment" ||
            cardDetailsModal?.title === "Incoming Shipment" ||
            cardDetailsModal?.title === "Available Bag"
            ? 1400
            : 400
        }
      >
        {cardDetailsModal?.title === "Incoming Bag" ? (
          <Table
            dataSource={incomingBagsData}
            columns={incomingBagsColumns}
            pagination={incomingBagsPagination}
            loading={isIncomingBagsLoading}
            onChange={handleIncomingBagsTableChange}
            rowKey="_sno"
            scroll={{ x: true }}
          />
        ) : cardDetailsModal?.title === "Outscan Bag" ? (
          <Table
            dataSource={outscanBagsData}
            columns={outscanBagsColumns}
            pagination={outscanBagsPagination}
            loading={isOutscanBagsLoading}
            onChange={handleOutscanBagsTableChange}
            rowKey="_sno"
            scroll={{ x: true }}
          />
        ) : cardDetailsModal?.title === "Outscan To CP Bags" ? (
          <Table
            dataSource={outscanToCPBagsData}
            columns={outscanToCPBagsColumns}
            pagination={outscanToCPBagsPagination}
            loading={isOutscanToCPBagsLoading}
            onChange={handleOutscanToCpBagsTableChange}
            rowKey="_sno"
            scroll={{ x: true }}
          />
        ) : cardDetailsModal?.title === "Outscan To CP Shipments" ? (
          <Table
            dataSource={outscanToCPShipmentsData}
            columns={outscanToCPShipmentsColumns}
            pagination={outscanToCPShipmentsPagination}
            loading={isOutscanToCPShipmentsLoading}
            onChange={handleOutscanToCpShipmentsTableChange}
            rowKey="_sno"
            scroll={{ x: true }}
          />
        ) : cardDetailsModal?.title === "Available Shipment" ? (
          <Table
            dataSource={inscanShipmentsData}
            columns={inscanShipmentsColumns}
            pagination={inscanShipmentsPagination}
            loading={isInscanShipmentsLoading}
            onChange={handleInscanShipmentsTableChange}
            rowKey="_sno"
            scroll={{ x: true }}
          />
        ) : cardDetailsModal?.title === "Outscan Shipment" ? (
          <Table
            dataSource={outscanShipmentsData}
            columns={outscanShipmentsColumns}
            pagination={outscanShipmentsPagination}
            loading={isOutscanShipmentsLoading}
            onChange={handleOutscanShipmentsTableChange}
            rowKey="_sno"
            scroll={{ x: 1800, y: 570 }}
          />
        ) : cardDetailsModal?.title === "Incoming Shipment" ? (
          <Table
            dataSource={incomingShipmentsData}
            columns={incomingShipmentsColumns}
            pagination={incomingShipmentsPagination}
            loading={isIncomingShipmentsLoading}
            onChange={handleIncomingShipmentsTableChange}
            rowKey="_sno"
            scroll={{ x: 2400, y: 570 }}
          />
        ) : cardDetailsModal?.title === "Available Bag" ? (
          <Table
            dataSource={inscanBagsData}
            columns={inscanBagsColumns}
            pagination={inscanBagsPagination}
            loading={isInscanBagsLoading}
            onChange={handleInscanBagsTableChange}
            rowKey="_sno"
            scroll={{ x: 2000, y: 570 }}
          />
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <h2>{cardDetailsModal?.count}</h2>
            <p>{cardDetailsModal?.title}</p>
          </div>
        )}
      </Modal>
    </div>
  );
}
Dashboard.propTypes = {
  data1: PropTypes.number,
};

export default Dashboard;

const CustomTabs = ({ activeTab, tabChange }) => {
  const tabStyles = (tab) => ({
    padding: "0 16px",
    height: "100%",
    textAlign: "center",
    color: activeTab === tab ? "#ffffff" : "#6b7280",
    fontFamily: "Roboto, sans-serif",
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0",
    cursor: "pointer",
    borderRadius: "8px",
    background: activeTab === tab ? "#2e77d0" : "transparent",
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap"
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        paddingLeft: "0",
        paddingTop: "0",
        height: "40px",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: "#f1f5f9",
          border: "1px solid #d6dee8",
          borderRadius: "10px",
          padding: "2px",
          width: "auto",
          height: "40px",
          gap: "3px",
          boxSizing: "border-box",
        }}
      >
        <div onClick={() => tabChange("cp")} style={tabStyles("cp")}>
          Overdue (3+ Days)
        </div>
        <div onClick={() => tabChange("hub")} style={tabStyles("hub")}>
          Live
        </div>
      </div>
    </div>
  );
};

const ShipmentStatusCompo = ({ array, styleObj }) => (
  <Row gutter={12} className="">
    {array?.map((item, i) => (
      <Col lg={6} md={6} sm={6} key={i}>
        <div
          className="shipmentStatusContainer"
          style={styleObj[item?.status]?.styles}
        >
          <div className="textNumber" style={styleObj[item?.status]?.textColor}>
            {item?.total_count}
          </div>
          <div>{capitalize(item?.status)}</div>
        </div>
      </Col>
    ))}
  </Row>
);

const StatusRow = ({ title, status, type, onCardClick }) => (
  <div className="status-section-card dashboard-white-card">
    <div className="status-section-title-card">
      <div className="status-section-title">
        <img
          src={type === "shipment" ? shipmentHeaderIcon : bagHeaderIcon}
          alt={`${title} icon`}
          className="status-section-title-icon"
        />
        {title}
      </div>
    </div>
    <div className="autoAdjust">
      <div>
        <StatusCard
          count={status.incoming}
          label={type === "shipment" ? "Incoming Shipment" : "Incoming Bag"}
          style={cardStyles.incoming}
          onClick={() => onCardClick && onCardClick(type === "shipment" ? "Incoming Shipment" : "Incoming Bag", status.incoming || 0)}
        />
      </div>
      <div>
        <StatusCard
          count={status.inscan}
          label={type === "shipment" ? "Available Shipment" : "Available Bag"}
          style={cardStyles.inscan}
          onClick={() => onCardClick && onCardClick(type === "shipment" ? "Available Shipment" : "Available Bag", status.inscan || 0)}
        />
      </div>
      <div>
        <StatusCard
          count={status.outscan}
          label={type === "shipment" ? "Outscan Shipment" : "Outscan Bag"}
          style={cardStyles.outscan}
          onClick={() => onCardClick && onCardClick(type === "shipment" ? "Outscan Shipment" : "Outscan Bag", status.outscan || 0)}
        />
      </div>
      <div>
        <StatusCard
          count={status.pending}
          label={type === "shipment" ? "Outscan To CP Shipments" : "Outscan To CP Bags"}
          style={cardStyles.pending}
          onClick={() => onCardClick && onCardClick(type === "shipment" ? "Outscan To CP Shipments" : "Outscan To CP Bags", status.pending || 0)}
        />
      </div>
    </div>
  </div>
);

const cardStyles = {
  incoming: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#175EB6",
  },
  inscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#008000",
  },
  pending: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#E28904",
  },
  outscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#353535",
  },
  pendingInscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#111827",
  },
  pendingOutscan: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E6EDF7",
    borderRadius: "10px",
    textColor: "#111827",
  },
};

const StatusCard = ({ count, label, style, onClick }) => (
  <Card bordered className="dashboard-status-card" style={{ ...style, cursor: onClick ? "pointer" : "default" }} onClick={onClick}>
    <div className="dashboard-status-count" style={{ color: style?.textColor || "#111827" }}>{count ? count : 0}</div>
    <div className="dashboard-status-label">{label}</div>
  </Card>
);
